import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: routes,
})

router.beforeEach((to, from, next) => {

    const components = router.getMatchedComponents({ ...to })

    if (components.length)
    {
        setTimeout(() => {
            router.app.setLayout(components[0].layout || '')
        }, 10)
    } else {
        router.app.seetLayout('')
    }

    next()

})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js